import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { qaId } from '../../../utils/index.js';
import { HEADER_QA_ID } from '../../../utils/qaId.js';
const WithLink = ({
  logoClickable,
  path,
  children
}) => logoClickable ? _jsx("a", {
  href: path,
  "data-cy": qaId(HEADER_QA_ID, 'logo', 'link'),
  "data-testid": qaId(HEADER_QA_ID, 'logo', 'link'),
  children: children
}) : children;
export default WithLink;